module.exports = {
      id: "thodargal-usage",
      viewBox: "0 0 22.5 23.3",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#thodargal",
      toString: function () {
        return this.url;
      }
    }